module.exports = __webpack_public_path__ + "static/media/Settings-icon.ce606f5b.svg";